import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { FormLabel } from '../../form-label';
import { Control, Controller, useWatch } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { InputNumber } from 'antd';
import { getShopConfig } from 'constant/shop';

const Price = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  const storeId = useWatch({ control, name: 'storeId' });
  const currency = getShopConfig(storeId).currency;

  return (
    <div className="flex items-center gap-2">
      <FormLabel required={false}>{i18n.t(LOCALS.selling_price)}:</FormLabel>
      <Controller
        name={`productList.${index}.price`}
        control={control}
        render={({ field }) => (
          <InputNumber
            {...field}
            inputMode="numeric"
            addonBefore={currency}
            className="w-full"
            min={0}
            max={99999999}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={(value) => value!.replace(/\$\s?|(,*)/g, '') as any}
          />
        )}
      />
    </div>
  );
};

export default Price;
